import React, {Suspense} from 'react'
import { CSSTransition, SwitchTransition } from 'react-transition-group';

import PendingResultsPanel from './PendingResultsPanel'

import {
  NeuroFitNamedLogoSvg,
  NeuroFitLogoSvg,
} from '../../constants/svgs'

import {
  isRtlLanguage,
} from '../../languageUtils'

import range from 'lodash/range'

import i18next from 'i18next'


import loadable from '@loadable/component'
const ChartistLineGraph = loadable(() => import('./ChartistLineGraph'))
// const chartistPluginAxisTitle = loadable(() => import('chartist-plugin-axistitle'))
// import ChartistLineGraph from './ChartistLineGraph';
// import chartistPluginAxisTitle from 'chartist-plugin-axistitle'

// Legend component to show below the chart
const GraphLegend = ({ legendConfig }) => {  
  return (
    <div style={{ display: 'flex', width: "100%", justifyContent: 'center', marginTop: '10px', gap: 10}}>
      {legendConfig.map((series, index) => (
        <div key={series.name} style={{ display: 'flex', alignItems: 'center', justifyContent: "center", gap: 5 }}>
          {/* Different line styles based on series type */}
          <div style={{ 
            width: '14px', 
            height: '2px', 
            backgroundColor: index === 0 ? series.color : 'transparent',
            borderBottom: index === 1 ? `2px dotted ${series.color}` : 
                          index === 2 ? `2px dashed ${series.color}` : 'none',
            display: 'inline-block'
          }} />
          <span style={{ fontSize: "14px", color: "#333", fontFamily: "Futura Book"}}>{i18next.t(series.name)}</span>
        </div>
      ))}
    </div>
  );
};

class LineGraph extends React.Component {

  constructor(props) {
    super(props)
  }

  preload() {
    ChartistLineGraph.preload()
  }

  render() {
    const {
      dataIsAvailable,
      title,
      data,
      dataCreationUnixTimestamp,
      labelInterpolationFnc,
      highYValue,
      pendingTitle,
      pendingText,
      xAxisTitle,
      hideLogo,
      marginTop,
      legendConfig
    } = this.props

    let formattedData = data
    // Process data for RTL handling
    const isRtl = isRtlLanguage()
    if (isRtl) {
      formattedData = {
        labels: data.labels.toReversed(),
        series: data.series.map(s => s.toReversed())
      };
    }

    return (
      <div>
        {dataIsAvailable ? (
          <div>
            <div style={{backgroundColor: "#FFFFFF", padding: "min(4vw, 20px)", marginTop: marginTop || "max(3vw, 16px)", boxShadow: "0px 1px 1.5px 0.5px #dddddd"}}>
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <div style={{display: "inline-block", fontFamily: "Futura", textTransform: "uppercase", fontWeight: "normal", fontSize: "min(5vw, 22px)", lineHeight: "min(5vw, 22px)"}}>
                  {title}
                </div>
              </div>
              <Suspense fallback={
                <div className={"article-loading-background-animation"} style={{height: 190, width: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}>
                  <NeuroFitLogoSvg
                    size={"min(8vw, 40px)"}
                    color={"#CFD2DD"}
                    lineColor={"#EDEEF2"}
                  />
                </div>
              }> 
                <SwitchTransition mode="out-in">
                  <CSSTransition
                    key={`line-graph-data-${dataCreationUnixTimestamp}`}
                    timeout={100}
                    classNames="hide-fade-in-150"
                    unmountOnExit
                  >
                    <div>
                      <ChartistLineGraph
                        data={formattedData}
                        options={{
                          height: '190px',
                          fullWidth: true,
                          chartPadding: {
                            top: 20, 
                            bottom: !!(xAxisTitle) ? 10 : 2,
                            left: 0,
                            right: 20
                          },
                          labelDirection: "explode",
                          axisY: {
                            labelInterpolationFnc,
                            low: 0,
                            high: highYValue,
                            referenceValue: 20,
                            onlyInteger: true,
                            offset: 50
                          },
                          axisX: {
                            // showGrid: false,
                            showGrid: true,
                            name: xAxisTitle,
                            showLabel: !!(xAxisTitle) && (!isRtl),
                            offset: (!!(xAxisTitle) && (!isRtl)) ? 10 : 0,
                          }
                        }}
                      />
                      {!hideLogo && (
                        <div style={{display: "flex", justifyContent: "end", alignItems: "center", marginTop: -40, paddingInlineEnd:30}}>
                          <NeuroFitNamedLogoSvg
                            logoSize={"min(4vw, 18px)"}
                            color={"#D5D6D9"}
                          />
                        </div>
                      )}
                      {legendConfig && (
                        <GraphLegend
                          legendConfig={legendConfig}
                        />
                      )}
                    </div>
                  </CSSTransition>
                </SwitchTransition>
              </Suspense>
              {!!(xAxisTitle) && (
                <div style={{textAlign: "center", fontFamily: "Futura", zIndex: -1, fontWeight: "normal", fontSize: "min(4vw, 18px)"}}>
                  {xAxisTitle}
                </div>
              )}
            </div>
          </div>
        ) : (
          <PendingResultsPanel
            title={pendingTitle}
            color={"#747a8c"}
            pendingText={pendingText}
          />
        )}
      </div>
    )
  }
}

export { ChartistLineGraph }; 
export default LineGraph;